import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const RequestFailedIcon = ({tintColor = '#fff', ...props}) => {
  return (
    <Svg
      width={55}
      height={56}
      viewBox="0 0 55 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M54.874 2.401A1.75 1.75 0 0052.599.126L1.684 20.493a2.625 2.625 0 00-.434 4.651l17.483 11.123 5.358 8.421a1.75 1.75 0 002.954-1.876l-4.816-7.567L48.46 9.016 41.825 25.6a1.75 1.75 0 103.248 1.302l9.8-24.5zm-8.89 4.14l-26.23 26.23-15.186-9.664L45.984 6.542z"
        fill={tintColor}
      />
      <Path
        d="M55 43.75a12.25 12.25 0 11-24.5 0 12.25 12.25 0 0124.5 0zm-16.989-4.739a1.75 1.75 0 000 2.478l2.264 2.261-2.264 2.261a1.752 1.752 0 002.478 2.478l2.261-2.264 2.261 2.264a1.752 1.752 0 002.478-2.478l-2.264-2.261 2.264-2.261a1.752 1.752 0 00-2.478-2.478l-2.261 2.264-2.261-2.264a1.75 1.75 0 00-2.478 0z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default RequestFailedIcon;
